import { render, staticRenderFns } from "./GsNameSelect.vue?vue&type=template&id=b5f435f0"
import script from "./GsNameSelect.vue?vue&type=script&lang=js"
export * from "./GsNameSelect.vue?vue&type=script&lang=js"
import style0 from "./GsNameSelect.vue?vue&type=style&index=0&id=b5f435f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports